// extracted by mini-css-extract-plugin
module.exports = {"root":"index__3LUBrt6o"};